<template>
  <customModal :containerxxxl="true" @closeModal="closeModal">
    <template #title> {{ modalTitle }} </template>
    <!-- <template #title> {{ modalTitle }} - {{ form.ctqId }} </template> -->
    <template #body>
      <div class="modal-scroll-body scrollable-y px-4">
        <form @submit.prevent="save">
          <!-- Identification -->
          <div class="form-group row my-0">
            <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">Risk ID <sup ><i class="fa fa-asterisk required"></i></sup></label>
              <input type="text" v-model="form.riskId" class="form-control" ref="riskId"
                :class="{ 'errorClass': errors.riskId }"
                placeholder="Risk ID" :disabled="isEdit"
                @input="errors.riskId = ''" />
              <div class="errorClass" v-if="errors.riskId">{{ errors.riskId }}</div>
            </div>
           <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">CTQ ID</label>
              <input type="text" v-model="form.ctqId" class="form-control" :disabled="ctqFieldsLocked" />
            </div>
            <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">CTQ Factor</label>
              <input type="text" v-model="form.ctqFactor" class="form-control" :disabled="ctqFieldsLocked" />
            </div>
          </div>

          <!-- Statement / Failure Mode -->
          <div class="form-group row my-0">
            <div class="col-12 px-1 mb-2">
              <label class="mb-0">Risk Statement <sup ><i class="fa fa-asterisk required"></i></sup></label>
              <textarea v-model="form.riskStatement" class="form-control" ref="riskStatement"
                :class="{ 'errorClass': errors.riskStatement }"
                rows="2" placeholder="Risk statement"
                @input="errors.riskStatement = ''"></textarea>
              <div class="errorClass" v-if="errors.riskStatement">{{ errors.riskStatement }}</div>
            </div>

            <div class="col-12 col-lg-6 px-1 mb-2">
              <label class="mb-0">Failure Mode</label>
              <textarea v-model="form.failureMode" class="form-control" rows="2" placeholder="Failure mode"></textarea>
            </div>
            <div class="col-12 col-lg-6 px-1 mb-2">
              <label class="mb-0">Root Cause</label>
              <textarea v-model="form.rootCause" class="form-control" rows="2" placeholder="Root cause"></textarea>
            </div>
            <div class="col-12 px-1 mb-2">
              <label class="mb-0">Consequence</label>
              <textarea v-model="form.consequence" class="form-control" rows="2" placeholder="Consequence"></textarea>
            </div>
          </div>

          <!-- Classification -->
          <div class="form-group row my-0">
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Risk Category</label>
              <input type="text" v-model="form.riskCategory" class="form-control" placeholder="Risk category" />
            </div>
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Sub-Category</label>
              <input type="text" v-model="form.subCategory" class="form-control" placeholder="Sub-category" />
            </div>
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Type Of Risk</label>
              <input type="text" v-model="form.typeOfRisk" class="form-control" placeholder="Type of risk" />
            </div>
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Phase</label>
              <input type="text" v-model="form.phase" class="form-control" placeholder="Phase" />
            </div>
          </div>

          <div class="form-group row my-0">
            <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">Level Of Scrutiny</label>
              <input type="text" v-model="form.levelOfScrutiny" class="form-control" placeholder="Level of scrutiny" />
            </div>
            <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">Detection Method</label>
              <input type="text" v-model="form.detectionMethod" class="form-control" placeholder="Detection method" />
            </div>
            <div class="col-12 col-lg-4 px-1 mb-2">
              <label class="mb-0">Risk Owner</label>
              <input type="text" v-model="form.riskOwner" class="form-control" placeholder="Risk owner" />
            </div>
          </div>

          <!-- Scoring -->
          <div class="form-group row my-0">
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">Probability</label>
              <input type="number" v-model.number="form.probability" class="form-control" min="0" />
            </div>
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">Impact</label>
              <input type="number" v-model.number="form.impact" class="form-control" min="0" />
            </div>
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">Detectability</label>
              <input type="number" v-model.number="form.detectability" class="form-control" min="0" />
            </div>
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">RPN</label>
              <input type="number" v-model.number="form.rpn" class="form-control" readonly />
            </div>
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">Risk Level</label>
              <input type="text" v-model="form.riskLevel" class="form-control" placeholder="Risk level" />
            </div>
            <div class="col-6 col-lg-2 px-1 mb-2">
              <label class="mb-0">Scoring Status</label>
              <input type="text" v-model="form.scoringStatus" class="form-control" placeholder="Scoring status" />
            </div>
          </div>

          <div class="form-group row my-0">
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Residual RPN</label>
              <input type="number" v-model.number="form.residualRpn" class="form-control" min="0" />
            </div>
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Residual Risk Level</label>
              <input type="text" v-model="form.residualRiskLevel" class="form-control" placeholder="Residual risk level" />
            </div>
             <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Status</label>
              <input type="text" v-model="form.status" class="form-control" placeholder="Status" />
            </div>
            <div class="col-12 col-lg-3 px-1 mb-2">
              <label class="mb-0">Execution Type</label>
              <input type="text" v-model="form.executionType" class="form-control" placeholder="Execution type" />
            </div>
          </div>

          <!-- Status -->
          <div class="form-group row my-0">
            <div class="col-12 col-lg-6 px-1 mb-2">
              <label class="mb-0">Score Rationale</label>
              <textarea v-model="form.scoreRationale" class="form-control"  placeholder="Score rationale"></textarea>
            </div>
            <div class="col-12 col-lg-6 px-1 mb-2">
              <label class="mb-0">Objectives</label>
              <textarea v-model="form.objectives" class="form-control"  placeholder="Objectives"></textarea>
            </div>
          </div>

          <div class="form-group row my-0 align-items-center">
            <div class="col-12 col-lg-3 px-1 mb-2 d-flex align-items-center">
              <input type="checkbox" v-model="form.isActive" id="riskIsActive" class="mr-2" />
              <label class="mb-0" for="riskIsActive">Active</label>
            </div>
          </div>

          <!-- Actions -->
          <div class="form-group row my-0 mt-3">
            <div class="col-12 d-flex justify-content-end">
              <span class="cancel_btn d-inline-block text-center px-3 py-1 mr-2" style="cursor: pointer;" @click="closeModal">
                Cancel
              </span>
              <span class="save_btn d-inline-block text-center px-3 py-1" style="cursor: pointer;" @click="save">
                {{ saving ? "Saving..." : "Save" }}
              </span>
            </div>
          </div>
        </form>
      </div>
    </template>
  </customModal>
</template>

<script src="./ManageRiskItemModal.js"></script>
<style>
.scrollable-y {
    overflow-y: scroll;
    height: 350px;
    overflow-x: hidden;
    background-color: #ffffff;
}

.scrollable-y {
    overflow-y: scroll;
    height: 350px;
    overflow-x: hidden;
    background-color: #ffffff;
}</style>